import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c20d11e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "cell-color" }, "From"),
    /*#__PURE__*/_createElementVNode("th", { class: "cell-color" }, "To"),
    /*#__PURE__*/_createElementVNode("th", null, "Buy"),
    /*#__PURE__*/_createElementVNode("th", null, "Sell"),
    /*#__PURE__*/_createElementVNode("th", null, "Adjust"),
    /*#__PURE__*/_createElementVNode("th", null, "Update On"),
    /*#__PURE__*/_createElementVNode("th", null, "Create On"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_5 = {
  key: 0,
  style: {"height":"1500px"}
}
const _hoisted_6 = { colspan: "12" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { colspan: "12" }
const _hoisted_9 = { class: "cell-color" }
const _hoisted_10 = { class: "cell-color" }
const _hoisted_11 = ["onClick"]

import { ref, onMounted } from "vue";
import TimeShow from "@/components/TimeShow.vue";
import RebateService from "../services/RebateService";
import TableFooter from "@/components/TableFooter.vue";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import ExchangeRateModal from "../components/ExchangeRateModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExchangeRate',
  setup(__props) {

const criteria = ref<any>({
  page: 1,
  size: 100,
  numPages: 1,
  total: 0,
});

const isUpdate = ref({
  true: true,
  false: false,
});

const isLoading = ref(true);
const deleteIndex = ref(-1);
const tableData = ref(Array<any>());
const ExchangeRateModalRef = ref<InstanceType<typeof ExchangeRateModal>>();

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const responseBody = await RebateService.getExchangeRate(criteria.value);
    criteria.value = responseBody.criteria;
    tableData.value = responseBody.data;
  } catch (error) {
    // console.log(error);
  } finally {
    isLoading.value = false;
  }
};
const refresh = () => {
  fetchData(criteria.value.page);
};
const showExRateDetail = (_isUpdate: boolean, _item?: object) => {
  ExchangeRateModalRef.value?.show(_isUpdate, _item);
};
onMounted(async () => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn btn-light btn-primary btn-lg me-3 mb-9",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showExRateDetail(isUpdate.value.false)))
      }, " Add Symbol "),
      _createElementVNode("table", _hoisted_3, [
        _hoisted_4,
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_6, [
                  _createVNode(ScaleLoader)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!isLoading.value && tableData.value.length === 0)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$t("tip.nodata")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (!isLoading.value && tableData.value.length != 0)
          ? (_openBlock(), _createBlock(_TransitionGroup, {
              key: 2,
              tag: "tbody",
              name: "table-delete-fade",
              class: "table-delete-fade-container text-gray-600 fw-semibold"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item,
                    class: _normalizeClass({ 'table-delete-fade-active': index === deleteIndex.value })
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.name), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(item.fromCurrencyCode), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(item.toCurrencyCode), 1),
                    _createElementVNode("td", null, _toDisplayString(item.buyingRate), 1),
                    _createElementVNode("td", null, _toDisplayString(item.sellingRate), 1),
                    _createElementVNode("td", null, _toDisplayString(item.adjustRate), 1),
                    _createElementVNode("td", null, [
                      _createVNode(TimeShow, {
                        "date-iso-string": item.updatedOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(TimeShow, {
                        "date-iso-string": item.createdOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "btn btn-light btn-success btn-sm me-3",
                        onClick: ($event: any) => (showExRateDetail(isUpdate.value.true, item))
                      }, _toDisplayString(_ctx.$t("action.details")), 9, _hoisted_11)
                    ])
                  ], 2))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(ExchangeRateModal, {
      ref_key: "ExchangeRateModalRef",
      ref: ExchangeRateModalRef,
      onRefresh: refresh
    }, null, 512)
  ]))
}
}

})